import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGraduateCap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconGraduateCap"><Path d="M23.25 8.99626L12 14.2425L0.75 8.99626L12 3.75L23.25 8.99626ZM23.25 8.99626V15.2418M4.75002 10.9636V14.8742C4.75002 15.9594 5.33687 16.9598 6.28438 17.4899L10.5344 19.8679C11.4449 20.3774 12.5551 20.3774 13.4656 19.8679L17.7157 17.4899C18.6632 16.9598 19.25 15.9594 19.25 14.8742V10.9636" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconGraduateCap;
